export default __webpack_public_path__ + "45ab0d631468bc76fa215e00534f72af.png";